import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import s from './ColorItem.css';

class ColorItem extends React.Component {
  static propTypes = {
    color: PropTypes.shape().isRequired,
    selectColor: PropTypes.func,
    isActive: PropTypes.bool,
  };

  static defaultProps = {
    isActive: false,
    selectColor: () => null,
  };

  handleClick = () => {
    const { color, selectColor } = this.props;
    selectColor(color.id);
  };

  render() {
    const { color, isActive } = this.props;

    const classname = cx(s.root, {
      [s.active]: isActive,
    });

    const style = {
      backgroundColor: `#${color.slug}`,
      border: `1px solid #${color.slug === 'ffffff' ? 'ccc' : color.slug}`,
    };

    return (
      <div className={classname} style={style} onClick={this.handleClick}>
        <div className={s.popover}>
          <FormattedMessage id={color.title} />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ColorItem);



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanel/ColorItem/ColorItem.js